import { ComponentProps } from 'react';

export function Edge(props: ComponentProps<'svg'>) {
  return (
    <svg
      viewBox="0 0 14 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M2.80218 8.62431C3.48882 3.68048 7.71581 0 12.7071 0H14V36H8.1879C3.33204 36 -0.404048 31.7091 0.263965 26.8995L2.80218 8.62431Z"
        fill="currentColor"
      />
    </svg>
  );
}
